import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { ResetPasswordPage } from '../pages/Auth/ResetPasswordPage'

export const Route = createFileRoute('/reset-password')({
  component: ResetPasswordRoute,
})

function ResetPasswordRoute() {
  const navigate = useNavigate()

  return (
    <ResetPasswordPage
      onBackToLogin={() => {
        navigate({ to: '/login' })
      }}
    />
  )
}
